import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    description: {
        marginTop: '26px',
        fontSize: '24px',
        color: theme.custom.textDarkColor,
    },
    descriptionControls: {
        marginTop: '6px',
        marginBottom: '20px',
    },
    buttonIcon: {
        marginRight: '3px',
    },
}));

export default useStyles;
